import { useEffect, useState } from 'react';
import { useGetTruckers } from 'api/truckers/truckers';
import { GetTruckerParams, Trucker } from 'api/truckers/truckers.types';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { FieldValues } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export default function TruckerAutocomplete<
  TFieldValues extends FieldValues = FieldValues,
>({ formProps, error }: { formProps: TFieldValues; error: boolean }) {
  const { data, loading, getTruckers } = useGetTruckers();
  const [options, setOptions] = useState<Trucker[]>([]);
  const [truckerParams, setTruckerParams] = useState<GetTruckerParams>({
    filterText: '',
    resultSize: 25,
    pageNumber: 1,
  });

  useEffect(() => {
    getTruckers(truckerParams);
  }, [getTruckers, truckerParams]);

  useEffect(() => {
    if (data?.length) {
      const filteredOptions = data.filter((trucker) => {
        if (!trucker.enabled) return false;
        const truckerBusinessFunction = trucker.businessFunctions?.find(
          (businessFunction) => businessFunction.__type === 'Trucker',
        );
        return truckerBusinessFunction?.enabled === true;
      });
      setOptions((prev) => [...prev, ...filteredOptions]);
    }
  }, [data]);

  return (
    <AutocompletePaginationAsync
      {...formProps}
      padding='dense'
      width={280}
      value={formProps.field.value}
      error={error}
      loading={loading}
      options={options}
      isOptionEqualToValue={(option, value) => value?.id === option?.id}
      getOptionLabel={(o) => o.code || o.counterpartyShortName}
      handleSearchChange={handleChange(setOptions, setTruckerParams)}
      onChange={(_, data) => formProps.field.onChange(data)}
      onScrollBottom={() =>
        setTruckerParams((prev: any) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }))
      }
      onBlur={createHandleOnBlur(
        setOptions,
        setTruckerParams,
        formProps.field.onBlur,
      )}
    />
  );
}
